import { useRef } from 'react';

/**
 * A LIST THAT KEEPS ITS IDENTITY WHILE ITS CONTENTS DO (plan shell-contexts, A3): the last array returned, as long
 * as the new one has the same length and every item the same `keyOf`; otherwise the new one. For a list rebuilt on
 * every render (filtered, sorted, mapped) that a context or a memoised child holds: rebuilt, it gave the context a
 * new value with each render, and every panel reading it rendered too.
 *
 * `keyOf` must cover everything a reader shows of an item - a field left out of it never reaches the screen when it
 * alone changes. Prefer "every field but the ones that tick" over "the fields shown today".
 *
 * @template T
 * @param {T[]} list
 * @param {(item: T) => string} keyOf
 * @returns {T[]}
 */
export default function useStableList(list, keyOf) {
  const kept = useRef(null);
  const keys = list.map(keyOf);
  const last = kept.current;
  const same = last && last.keys.length === keys.length && keys.every((k, i) => k === last.keys[i]);
  if (!same) kept.current = { keys, list };
  return kept.current.list;
}
